import {FieldTypeEnum} from '../dynamic-field/field-type.enum';
import {ControlUpdater} from '../dynamic-field/control-updater.type';
import {textFieldControlUpdater} from './text/text-field.updater';
import {numberFieldControlUpdater} from './number/number-field.updater';
import {textareaFieldControlUpdater} from './textarea/text-area-field.updater';
import {checkboxFieldControlUpdater} from './checkbox/checkbox-field.updater';
import {multiOptionFieldControlUpdater} from "./multi-option/multi-option.updater";
import {chipsFieldControlUpdater} from "./chips/chips-field.updater";
import {chipsMultiSelectFieldControlUpdater} from "./chips-multiselect/chips-multiselect-field.updater";
import {FilterSelectControlUpdater} from "./filter-select/filter-select.updater";
import {SlideToggleControlUpdater} from "./slidetoggle/slide-toggle.updater";

export const fieldTypeToControlUpdater = new Map<FieldTypeEnum, ControlUpdater>([
    [FieldTypeEnum.number, numberFieldControlUpdater],
    [FieldTypeEnum.text, textFieldControlUpdater],
    [FieldTypeEnum.textarea, textareaFieldControlUpdater],
    [FieldTypeEnum.checkbox, checkboxFieldControlUpdater],
    [FieldTypeEnum.multiOption, multiOptionFieldControlUpdater],
    [FieldTypeEnum.chips, chipsFieldControlUpdater],
    [FieldTypeEnum.chipsMultiSelect, chipsMultiSelectFieldControlUpdater],
    [FieldTypeEnum.filterSelect, FilterSelectControlUpdater],
    [FieldTypeEnum.slidetoggle, SlideToggleControlUpdater]
]);
